import { createMuiTheme } from '@material-ui/core/styles';

import { isRtl } from 'modules/language/selectors/language';
import {
  primaryLight,
  primaryMedium,
  whiteMedium,
  blackMedium,
  whiteLight,
  blackLight,
  primaryMediumAccessible,
  primaryLightAccessible,
  redMedium,
  redMediumAccessible,
  grayMedium,
  whiteHard,
} from './getColors';

export default function getMuiTheme(isAccessibilityEnabled) {
  return createMuiTheme({
    direction: isRtl() ? 'rtl' : 'ltr',

    typography: {
      fontFamily: isRtl() ? ['"Open Sans Hebrew"'] : ['"Open Sans"'],
    },

    palette: {
      primary: {
        main: isAccessibilityEnabled ? primaryMediumAccessible : primaryMedium,
        light: isAccessibilityEnabled ? primaryLightAccessible : primaryLight,
      },
      error: {
        main: isAccessibilityEnabled ? redMediumAccessible : redMedium,
      },
    },

    zIndex: {
      modal: 100,
    },

    topArrow: {
      overflow: 'visible',
      border: '1px solid #bbbbbb',
      transform: 'translateY(20px) !important',

      '&:before': {
        content: '""',
        top: -10,
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px',
        borderColor: 'transparent transparent #bbbbbb',
        left: '50%',
        width: 0,
        transform: 'translateX(-50%)',
      },

      '&:after': {
        content: '""',
        top: -9,
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '0 9px 9px',
        borderColor: 'transparent transparent white',
        left: '50%',
        width: 0,
        transform: 'translateX(-50%)',
      },
    },

    topRightArrow: {
      overflow: 'visible',
      border: '1px solid #bbbbbb',
      transform: 'translateY(20px) !important',

      '&:before': {
        content: '""',
        top: -10,
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px',
        borderColor: 'transparent transparent #bbbbbb',
        right: '10px',
        width: 0,
      },

      '&:after': {
        content: '""',
        top: -9,
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: '0 9px 9px',
        borderColor: 'transparent transparent white',
        right: '11px',
        width: 0,
      },
    },

    overrides: {
      MuiSwitch: {
        switchBase: {
          color: isAccessibilityEnabled ? '#B4ACD2' : blackLight,

          '&$checked': {
            color: isAccessibilityEnabled ? primaryMediumAccessible : primaryMedium,

            '& + $track': {
              backgroundColor: isAccessibilityEnabled
                ? primaryMediumAccessible
                : primaryMedium,
            },

            '& $thumb': {
              color: isAccessibilityEnabled ? primaryMediumAccessible : primaryMedium,
            },

            '&$disabled $thumb': {
              color: '#B4ACD2',
            },
          },

          '&$disabled $thumb': {
            color: isAccessibilityEnabled ? grayMedium : whiteHard,
          },
        },
        track: {
          opacity: 1,
          backgroundColor: 'rgba(40, 40, 40, 0.26)',
        },
        thumb: {
          color: isAccessibilityEnabled ? blackLight : whiteLight,
        },
        checked: {},
        disabled: {},
      },

      MuiPickersToolbarText: {
        toolbarTxt: isAccessibilityEnabled ? { color: whiteLight } : {},
      },

      MuiPickersCalendarHeader: {
        dayLabel: isAccessibilityEnabled ? { color: blackLight } : {},
        iconButton: isAccessibilityEnabled ? { color: blackLight } : {},
      },

      MuiMenu: {
        paper: {
          borderRadius: 10,
          boxShadow: '0 7px 19px 0 rgba(0, 0, 0, 0.2)',
        },
      },

      MuiMenuItem: {
        root: {
          minHeight: 40,
        },
        gutters: {
          paddingLeft: 10,
          paddingRight: 10,
        },
      },

      MuiAccordion: {
        root: {
          border: '1px solid rgba(0,0,0,.125)',
          boxShadow: 'none',
          borderBottom: 0,

          '&:before': {
            display: 'none',
          },

          '&$expanded': {
            margin: 0,
          },
        },
      },

      MuiAccordionSummary: {
        root: {
          padding: '0 15px',
          backgroundColor: whiteMedium,
          minHeight: 56,

          '&$expanded': {
            minHeight: 56,
            '&$root': {
              borderBottom: '1px solid rgba(0,0,0,.125)',
            },
          },

          '&:hover $expandIcon': {
            color: blackMedium,
          },
        },
        content: {
          flexDirection: 'column',
          margin: '10px 0',

          '&$expanded': {
            margin: '10px 0',
          },
        },
        expandIcon: {
          right: 0,
        },
        expanded: {},
      },

      MuiAccordionDetails: {
        root: {
          padding: '8px 15px',
        },
      },
    },
  });

}
